import styled from "styled-components";
import { TableFlex } from "@8x8/oxygen-table";

import StyledTableCell from "@/react/components/styled/table/StyledTableCell";
import StyledTableRow from "@/react/components/styled/table/StyledTableRow";

import useStickyOffsets from "./useStickyOffsets";

const FLOATING_COLUMN_Z_INDEX = 2;

const Styled = styled(TableFlex)`
  position: relative;
  flex-grow: 1;
  flex-shrink: 1;
  overflow-x: hidden;
  flex-basis: 0;

  ${StyledTableRow} {
    ${({ stickyOffsets }) =>
      stickyOffsets.map(
        ({ offset, index, position }) => `
        ${StyledTableCell}:nth-child(${index + 1}) {
          position: sticky;
          ${position}: ${offset}px;
          z-index: ${FLOATING_COLUMN_Z_INDEX};
        }
      `
      )}
  }
`;

export const StyledTableFlex = ({ columns, ...rest }) => {
  const stickyOffsets = useStickyOffsets(columns);
  return <Styled stickyOffsets={stickyOffsets} {...rest} />;
};
